import React from 'react';
import { FormationsType } from 'types/formation/formations.def';
import { PedagogiesType } from 'types/pedagogies/pedagogies.def';
import useGoToPage from 'hooks/useGoToPage';
import pages from 'routes/pages';
import { classNames } from 'helpers/style/classNames';
import useStyle from './ressourcesTypeButton.style';

interface RessourcesTypeButtonProps {
  ressourcesType: FormationsType | PedagogiesType;
  variant: 'red' | 'blue' | 'orange';
}

export const RessourcesTypeButton = ({
  ressourcesType,
  variant
}: RessourcesTypeButtonProps) => {
  const classes = useStyle();
  const path = () => {
    switch (variant) {
      case 'red':
        return pages.FORMATIONS_TYPE_PAGE.path;
      case 'blue':
        return pages.PEDAGOGIES_TYPE_PAGE.path;
      default:
        return pages.RESSOURCES_TYPE_PAGE.path;
    }
  };

  const toFormationRessourcePage = useGoToPage(path(), {
    id: ressourcesType.id
  });
  return (
    <div
      onClick={toFormationRessourcePage}
      className={classNames([classes.root, classes[variant]])}
    >
      {ressourcesType.name}
    </div>
  );
};
